const TOKEN = "token";
const TOKEN_TYPE = "tokenType";
const AUTHORIZATION = "Authorization";
const USER = "user";
const MENU = "menu";
const CODE = "code";

export { TOKEN, TOKEN_TYPE, AUTHORIZATION, USER, MENU, CODE };
